var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Bluebird from "bluebird";
import Cache from "../services/Cache";
function createLoader(_a) {
    var download = _a.download, load = _a.load, restore = _a.restore, getID = _a.getID, cacheName = _a.cacheName;
    var loading = {};
    var byId = {};
    var cache = new Cache(cacheName);
    var considerLoaded = function (id) {
        loading = __assign({}, loading);
        delete loading[id];
    };
    var cacheInMemory = function (id, instance) {
        byId = __assign({}, byId, (_a = {}, _a[id] = instance, _a));
        return instance;
        var _a;
    };
    var loadFromCache = function (id) {
        return cache.get(id)
            .then(function (cacheResponse) { return cacheResponse.data; })
            .then(restore)
            .then(function (instance) {
            cacheInMemory(id, instance);
            considerLoaded(id);
            return instance;
        });
    };
    var serverResponseToInstance = function (response, id) {
        return load(response)
            .then(function (cacheableData) { return cache.store(id, cacheableData).thenReturn(cacheableData); })
            .then(restore)
            .then(function (instance) { return cacheInMemory(id, instance); })
            .finally(function () { return considerLoaded(id); });
    };
    return _b = /** @class */ (function () {
            function ObjectLoader() {
            }
            ObjectLoader.getLoaded = function (id) {
                if (!ObjectLoader.isLoaded(id)) {
                    throw new Error("Not yet loaded: " + id);
                }
                return byId[id];
            };
            ObjectLoader.isLoaded = function (id) {
                return byId.hasOwnProperty(id);
            };
            // Throws
            ObjectLoader.getFromCache = function (id) {
                if (byId[id]) {
                    return Bluebird.resolve(byId[id]);
                }
                return loadFromCache(id);
            };
            ObjectLoader.load = function (response) {
                var id = getID(response);
                if (byId[id]) {
                    return Bluebird.resolve(byId[id]);
                }
                if (!loading[id]) {
                    loading = __assign({}, loading, (_a = {}, _a[id] = loadFromCache(id).catch(function () { return serverResponseToInstance(response, id); }), _a));
                }
                return loading[id];
                var _a;
            };
            ObjectLoader.get = function (id) {
                if (typeof id === "undefined" || id === null) {
                    throw new Error("Can't get object with id " + id + " - " + cacheName);
                }
                if (byId[id]) {
                    return Bluebird.resolve(byId[id]);
                }
                if (!loading[id]) {
                    var promise = loadFromCache(id)
                        .catch(function () { return download(id).then(function (response) { return serverResponseToInstance(response, id); }); });
                    loading = __assign({}, loading, (_a = {}, _a[id] = promise, _a));
                }
                return loading[id];
                var _a;
            };
            return ObjectLoader;
        }()),
        _b.getAll = function () {
            return byId;
        },
        _b.removeLoaded = function (id) { return delete byId[id]; },
        _b.addLoaded = function (id, obj) {
            byId[id] = obj;
        },
        _b;
    var _b;
}
export default createLoader;



//////////////////
// WEBPACK FOOTER
// ./js/services/cachedObjectLoader.ts
// module id = EkNv
// module chunks = 1 2 3